module.exports = __webpack_public_path__ + "static/media/seguros-mundial-star.d20e7a5b.svg";